export function render_error_bar(): string {
  return `
    <div id="error-bar" style="display:none">
      <div class="error-bar-content">
        <div class="d-flex justify-content-between align-items-start mb-3">
          <div>
            <h5 class="mb-2" id="error-title">
              <i class="fas fa-exclamation-triangle me-2"></i>
              Erro
            </h5>
            <p class="mb-0" id="error-message">Ocorreu um erro</p>
          </div>
          <button type="button" class="btn btn-sm btn-outline-light" data-error-bar-close title="Fechar" aria-label="Fechar aviso de erro">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="error-method-info" id="error-method-info"></div>
        <div class="d-flex justify-content-between align-items-center mb-2">
          <strong><i class="fas fa-bug me-2"></i>Detalhes</strong>
          <button type="button" class="btn btn-sm btn-outline-light" data-error-bar-toggle id="error-details-toggle" aria-expanded="false" aria-controls="error-details">
            <i class="fas fa-chevron-down me-1"></i>Mostrar Detalhes
          </button>
        </div>
        <div class="error-details" id="error-details" style="display:none"></div>
      </div>
    </div>`
}

function set_details_visible(bar: HTMLElement, visible: boolean): void {
  const details = bar.querySelector<HTMLElement>('#error-details')
  const toggle = bar.querySelector<HTMLElement>('[data-error-bar-toggle]')
  if (details) details.style.display = visible ? 'block' : 'none'
  if (!toggle) return
  toggle.setAttribute('aria-expanded', String(visible))
  toggle.innerHTML = visible
    ? '<i class="fas fa-chevron-up me-1"></i>Ocultar Detalhes'
    : '<i class="fas fa-chevron-down me-1"></i>Mostrar Detalhes'
}

// Os dois botões da barra chamavam `window.hideErrorBar()` e
// `window.toggleErrorDetails()` por onclick inline, e nenhuma das funções existiu
// em momento algum: clicar lançava TypeError no runtime do cliente. O comportamento
// agora fica no próprio componente, sem handler inline (que também depende de CSP
// permissiva) e sem alocar função nova no window.
function bind_error_bar(bar: HTMLElement): void {
  bar.querySelector<HTMLElement>('[data-error-bar-close]')?.addEventListener('click', () => {
    bar.style.display = 'none'
    set_details_visible(bar, false)
  })
  bar.querySelector<HTMLElement>('[data-error-bar-toggle]')?.addEventListener('click', () => {
    const details = bar.querySelector<HTMLElement>('#error-details')
    set_details_visible(bar, details?.style.display === 'none')
  })
}

export function mount_error_bar(): void {
  const el = document.getElementById('error-bar')
  if (!el) return
  el.outerHTML = render_error_bar()
  const mounted = document.getElementById('error-bar')
  if (mounted) bind_error_bar(mounted)
}
